import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import type { BorrowMarketsSortState } from '@/types/borrowMarketsSortState'
import { sortBorrowMarkets } from '@/utils/borrowMarkets/sortBorrowMarkets'
import { useMemo } from 'react'

interface SortedBorrowMarketsProps extends BorrowMarketsSortState {
  borrowMarkets: BorrowMarketRow[]
}

export function useSortedBorrowMarkets({ borrowMarkets, sortBy, asc }: SortedBorrowMarketsProps) {
  return useMemo(() => sortBorrowMarkets(borrowMarkets, { sortBy, asc }), [borrowMarkets, sortBy, asc])
}
